import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

// Define the state shape
export interface WarehouseStockState {
    isStockAvailable?: boolean;
    productId?: string;
}

// Initial state
const initialState: WarehouseStockState = {
    isStockAvailable: true,
    productId: "",
};

// Reducer map
const StockWarehouseReducer = {
    "Custom/WarehouseStock/SetWarehouseStockState": (
        draft: Draft<WarehouseStockState>,
        action: {
            data: WarehouseStockState;
        },
    ) => {
        draft.isStockAvailable = action.data.isStockAvailable;
        draft.productId = action.data.productId;
    },
};

export default createTypedReducerWithImmer(initialState, StockWarehouseReducer);
